<template>
  <span v-if="visible" class="navBadge">
    <span v-if="divider" class="divider" aria-hidden="true"></span>
    <template v-if="variant === 'activity'">
      <span v-if="running > 0" class="part">
        <span class="dot dotRunning" aria-hidden="true"></span>
        <span class="count">{{ running }}</span>
      </span>
      <span v-if="queued > 0" class="part">
        <span class="dot dotQueued" aria-hidden="true"></span>
        <span class="count">{{ queued }}</span>
      </span>
    </template>
    <span v-else class="count">{{ count }}</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  // 'count' = single number; 'activity' = split running/queued.
  variant:  { type: String, default: 'count' },
  count:    { type: Number, default: 0 },
  running:  { type: Number, default: 0 },
  queued:   { type: Number, default: 0 },
  divider:  { type: Boolean, default: true },
})

const visible = computed(() => {
  if (props.variant === 'activity') return props.running > 0 || props.queued > 0
  return props.count > 0
})
</script>

<style scoped>
.navBadge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  font-size: var(--fs-sm);
  font-weight: var(--fw-semibold);
  line-height: 1;
  color: var(--color-text-primary);
}
.divider {
  display: inline-block;
  width: 1px;
  height: 14px;
  margin-left: var(--space-2);
  background: var(--color-border-strong);
  opacity: 0.55;
}
.part {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}
.count { font-variant-numeric: tabular-nums; }

.dot {
  width: 7px;
  height: 7px;
  border-radius: var(--radius-full);
  flex-shrink: 0;
}
.dotRunning {
  background: var(--color-accent);
  animation: navBadgeRunPulse 1.5s ease-in-out infinite;
}
.dotQueued { background: var(--color-text-tertiary); }

@keyframes navBadgeRunPulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50%      { opacity: 0.45; transform: scale(0.8); }
}

</style>
